// extracted by mini-css-extract-plugin
export var active = "_ac-7";
export var container = "_ac-0";
export var evenWidth = "_ac-4";
export var large = "_ac-5";
export var outlet = "_ac-8";
export var slide = "_ac-2";
export var small = "_ac-6";
export var tab = "_ac-3";
export var tabs = "_ac-1";